import uiReader from '../../store/readHelpers/uiReader';

export const optionKeys = {
    addExtraTime: 'addExtraTime',
    backToDashboard: 'backToDashboard',
    deliverBlank: 'deliverBlank',
    hideRemainingTime: 'hideRemainingTime',
    language: 'language',
    submitBlank: 'submitBlank',
    withdraw: 'withdraw',
};

const defaults = {
    addExtraTime: true,
    backToDashboard: true,
    deliverBlank: true,
    hideRemainingTime: true,
    language: true,
    submitBlank: true,
    withdraw: true,
};

const fjord = {
    backToDashboard: false,
    hideRemainingTime: false,
    language: false,
    submitBlank: false,
};

const overrides = {
    fjord,
};

function getOptionsForTheme(marketPlace) {
    if (overrides[marketPlace]) {
        return { ...defaults, ...overrides[marketPlace] };
    }
    return defaults;
}

const optionsAvailabilityOverrides = {
    isAvailableWithCurrentTheme(option) {
        const theme = uiReader.getMarketplaceTheme();
        return getOptionsForTheme(theme)[option] !== false;
    },
};

export default optionsAvailabilityOverrides;
